{
  "salon-search-container": {
    "text": {
      "find-salon": "Ihren Salon suchen",
      "find-salon-hint": "Bitte wählen Sie die gewünschte Stadt des Salons"
    }
  }
}
